"use client";

import { Canvas, type CanvasProps } from "@react-three/fiber";
import { useMemo, type ReactNode } from "react";
import { isWebGLUsable } from "./is-webgl-usable";

export interface SafeR3FCanvasProps extends CanvasProps {
	/** Rendered when WebGL cannot be created (default: null). */
	fallback?: ReactNode;
}

/**
 * R3F {@link Canvas} that only mounts when WebGL preflight passes.
 * Avoids the Three `getShaderPrecisionFormat(...).precision` crash that
 * {@link SafeWebGLBoundary} cannot catch (layout-effect throw).
 */
export function SafeR3FCanvas({
	fallback = null,
	children,
	...props
}: SafeR3FCanvasProps) {
	const usable = useMemo(() => isWebGLUsable(), []);
	if (!usable) {
		return fallback;
	}
	return <Canvas {...props}>{children}</Canvas>;
}
